import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import Service from './Service/Service'

interface ServicesProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const Services = (props: ServicesProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Services">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Services"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="serviceIds"
          // @ts-expect-error
          entityListItemComponent={Service}
        />
      </Box>
    </DashboardModule>
  )
}

export default Services
